'use client';
import { Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { SummaryItem, SummaryTable } from '../saleSummary/style';

type PlanDetailsProps = {
  formattedInfo: Array<{ key: string; value: string }>;
};

export function PlanDetails({ formattedInfo }: PlanDetailsProps) {
  const { formatMessage } = useIntl();
  return (
    <SummaryTable>
      <Text variant="heading-xsmall" color="high">
        {formatMessage({ id: 'recurrence.interval.details' })}
      </Text>
      {formattedInfo.map((info) => (
        <SummaryItem key={info.key}>
          <Text color="medium" weight="medium">
            {info.key}
          </Text>
          <Text color="medium" weight="semibold">
            {info.value}
          </Text>
        </SummaryItem>
      ))}
    </SummaryTable>
  );
}
